import React from 'react';

import { lensTokens } from '~/configs/unifiedAnalyticsTheme';

import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

import SurfaceChip from './surface/SurfaceChip';

const BETA_LABEL = 'Beta';

export function BetaBadge({ inverted = false }: { inverted?: boolean }) {
  return <SurfaceChip inverted={inverted} label={BETA_LABEL} />;
}

/** The page-title Beta mark: Ocean Teal outline, 10.5px caps, 4px radius. */
export function PageBetaBadge() {
  const theme = useTheme();
  const tokens = lensTokens(theme);

  return (
    <Box
      aria-label={BETA_LABEL}
      component="span"
      sx={{
        border: `1px solid ${tokens.accent}`,
        borderRadius: '8px',
        color: tokens.accent,
        fontSize: '10.5px',
        letterSpacing: '0.08em',
        lineHeight: '16px',
        px: '6px',
        textTransform: 'uppercase',
      }}
    >
      {BETA_LABEL}
    </Box>
  );
}

/** One outline style for every Beta mark in the rail: 10px caps in a hairline pill. */
export function RailBetaBadge() {
  const theme = useTheme();
  const tokens = lensTokens(theme);

  return (
    <Box
      aria-label={BETA_LABEL}
      component="span"
      sx={{
        border: `1px solid ${alpha(tokens.railText, 0.4)}`,
        borderRadius: '8px',
        color: alpha(tokens.railText, 0.72),
        flex: 'none',
        fontSize: '10px',
        letterSpacing: '0.06em',
        lineHeight: '14px',
        mr: 0.5,
        px: '5px',
        textTransform: 'uppercase',
      }}
    >
      {BETA_LABEL}
    </Box>
  );
}
